import { cn } from '@/lib/utils';
import { sanitizeHtml, toRichTextHtml } from '@/util/util_richText';

// Renders HTML written in the admin's `RichTextField`.
//
// Sanitized again here rather than trusted from Firestore: the stored string is
// whatever was in the document, and a value that reaches the page through some
// other route (an import script, a hand-edited document) has never been through
// DOMPurify. Tailwind's preflight strips list and emphasis styling, so the
// element styles are restored below.

interface RichTextProps {
  /** HTML, or legacy plain text (one paragraph per line). */
  html: string;
  className?: string;
}

export function RichText({ html, className }: RichTextProps) {
  const clean = sanitizeHtml(toRichTextHtml(html));
  if (clean === '') return null;

  return (
    <div
      className={cn(
        'tw:space-y-4',
        'tw:[&_ul]:list-disc tw:[&_ul]:space-y-1 tw:[&_ul]:pl-5',
        'tw:[&_ol]:list-decimal tw:[&_ol]:space-y-1 tw:[&_ol]:pl-5',
        'tw:[&_strong]:font-semibold tw:[&_strong]:text-ed-black',
        'tw:[&_em]:italic',
        'tw:[&_a]:text-ed-gold tw:[&_a]:underline tw:[&_a]:underline-offset-2',
        'tw:[&_blockquote]:border-l-2 tw:[&_blockquote]:border-ed-gold/40 tw:[&_blockquote]:pl-4',
        className,
      )}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
